/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Reward_TextInputs */

const en_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic Pass`)
};

const ar_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البطاقة الأساسية`)
};

const de_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basis-Pass`)
};

const es_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pase básico`)
};

const fr_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe basique`)
};

const it_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass base`)
};

const ja_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベーシックパス`)
};

const ko_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 패스`)
};

const pt_br_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passaporte Básico`)
};

const ru_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовый пропуск`)
};

const th_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัตรผ่านพื้นฐาน`)
};

const tr_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standart Bilet`)
};

const zh_cn_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础通行证`)
};

const zh_tw_event_reward_text = /** @type {(inputs: Event_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基礎通行證`)
};

/**
* | output |
* | --- |
* | "Basic Pass" |
*
* @param {Event_Reward_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_reward_text = /** @type {((inputs?: Event_Reward_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Reward_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_reward_text(inputs)
	if (locale === "ar") return ar_event_reward_text(inputs)
	if (locale === "de") return de_event_reward_text(inputs)
	if (locale === "es") return es_event_reward_text(inputs)
	if (locale === "fr") return fr_event_reward_text(inputs)
	if (locale === "it") return it_event_reward_text(inputs)
	if (locale === "ja") return ja_event_reward_text(inputs)
	if (locale === "ko") return ko_event_reward_text(inputs)
	if (locale === "pt_br") return pt_br_event_reward_text(inputs)
	if (locale === "ru") return ru_event_reward_text(inputs)
	if (locale === "th") return th_event_reward_text(inputs)
	if (locale === "tr") return tr_event_reward_text(inputs)
	if (locale === "zh_cn") return zh_cn_event_reward_text(inputs)
	return zh_tw_event_reward_text(inputs)
});